import { render, staticRenderFns } from "./AppSimpleDialog.vue?vue&type=template&id=6139c9ee&scoped=true"
import script from "./AppSimpleDialog.vue?vue&type=script&lang=js"
export * from "./AppSimpleDialog.vue?vue&type=script&lang=js"
import style0 from "./AppSimpleDialog.vue?vue&type=style&index=0&id=6139c9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139c9ee",
  null
  
)

export default component.exports